import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import HomeAppBar from "../../components/HomeAppBar/HomeAppBar";
import { useTheme } from "../../contexts/ThemeContext";

export default function Dashboard({ theme, user, permissionConfig }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const containerStyle = { ...theme.container };
    containerStyle.backgroundColor = theme.palette.background.default;
    containerStyle.p = "0px !important";
    containerStyle.m = "0px !important";

    return (
        <>
            <Container sx={containerStyle}>
                <HomeAppBar
                    selectedPage="dashboard"
                    user={user}
                    permissionConfig={permissionConfig}
                />
                <Box
                    sx={{
                        p: 3,
                        color: theme.palette.text.primary,
                    }}
                >
                    <Typography variant="h4">Dashboard</Typography>
                </Box>
            </Container>
        </>
    );
}
